import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';

// Konfigurasi axios global untuk mengarah ke backend yang benar
// Gunakan URL absolut untuk production
axios.defaults.baseURL = 'https://event.petirs.id/backend';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 